import { DefaultRootState } from 'react-redux';

import fetcher from 'api/fetcher';

import { BidFrequencyStatus } from 'store/models/auctionData';
import {
    Audience,
    setMultiCreationBidFrequencyStatusLoading,
    updateMultiCreationAuctionsBidFrequencyStatus,
    VacancyBids,
} from 'store/models/multiCreation';
import { AppDispatch } from 'store/utils';

export interface VacancyBidRating {
    maxBidAmongSimilarVacancies: number;
    recommendedBudget: number;
    competingCampaignBids: number[];
    competingCampaignIds: number[];
    bidFrequencyStatus: BidFrequencyStatus;
    oftenThresholdBid: number;
    averageThresholdBid: number;
    winProbability: number;
    action: number;
    audience: Audience;
}

type VacancyId = number;

export type VacancyBidRatings = Record<VacancyId, VacancyBidRating>;

interface BidRatingResponse {
    vacancyBidRatings: VacancyBidRatings;
}

export const fetchBatchBidRating = (bidValue: number) => {
    return async (dispatch: AppDispatch, getState: () => DefaultRootState): Promise<void> => {
        const state = getState();
        const auctionsToCreate = state.multiCreation.auctionsToCreate;

        const data: VacancyBids[] = Object.keys(auctionsToCreate).map((key) => {
            const vacancyId = Number(key);
            return {
                vacancyId,
                bidInCents: bidValue,
            };
        });

        const body = { vacancyBids: data };

        try {
            dispatch(setMultiCreationBidFrequencyStatusLoading(true));

            const result = await fetcher.post<unknown, BidRatingResponse>('/api/v1/auction/bid_rating/batch', body);

            const vacancyBidsRatings = Object.entries(result.vacancyBidRatings).map(([vacancyIdStr, bidRating]) => ({
                vacancyId: Number(vacancyIdStr),
                bidFrequencyStatus: bidRating.bidFrequencyStatus,
            }));

            dispatch(updateMultiCreationAuctionsBidFrequencyStatus(vacancyBidsRatings));
        } catch (e) {
            const vacancyBidsRatingsWithNull = Object.keys(auctionsToCreate).map((key) => ({
                vacancyId: Number(key),
                bidFrequencyStatus: null,
            }));

            dispatch(updateMultiCreationAuctionsBidFrequencyStatus(vacancyBidsRatingsWithNull));
        } finally {
            dispatch(setMultiCreationBidFrequencyStatusLoading(false));
        }
    };
};
